import { render, staticRenderFns } from "./Handler.vue?vue&type=template&id=0aa762b3"
import script from "./Handler.vue?vue&type=script&lang=js"
export * from "./Handler.vue?vue&type=script&lang=js"
import style0 from "./Handler.vue?vue&type=style&index=0&id=0aa762b3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports